export default {
    // cn_regions: [
    //     "青洲",
    //     "台山",
    //     "黑沙環",
    //     "筷子基",
    //     "新橋",
    //     "沙梨頭",
    //     "大三巴",
    //     "荷蘭園",
    //     "皇朝",
    //     "南灣",
    //     "新馬路",
    //     "水坑尾",
    //     "新口岸",
    //     "東望洋",
    //     "司打口",
    //     "下環",
    //     "媽閣",
    //     "氹仔",
    //     "路氹城",
    //     "路環",
    //     "橫琴",
    // ],
    cn_regions: [
        "香港",
        "澳門"
    ],
    cn_type: [
        "博彩業",
        "工業",
        "服務業",
        "郵電",
        "通信",
        "社區服務",
        "批發",
        "零售業",
        "慈善機構"
    ],
    en_regions: [
        "香港",
        "澳門"
    ],
    en_type: [
        "en",
        "工業",
        "服務業",
        "郵電",
        "通信",
        "社區服務",
        "批發",
        "零售業",
        "慈善機構"
    ],
}